import React, {useContext} from 'react'
import {EditOutlined} from '@ant-design/icons'
import ListBrandsContext from "../../context/ListBrandsContext";
import timeHumanize from "../../../helpers/timeHumanize";
import moment from "moment";
import { canViewStoreName as checkStoreName } from '../../../../services/StorageServices'

const TableRow = (props) => {
    const {handleClickEditBrand} = useContext(ListBrandsContext)
    const {brand} = props
    const canViewStoreName = checkStoreName()

    const _handleClickEdit = () => {
        handleClickEditBrand(brand._id,brand.name, brand.store)
    }

    return (
        <tr className="TableRow">
            <td className="name">{brand.name}</td>
            {canViewStoreName && <td className="store">{brand.store}</td>}
            <td>{moment(brand.created_at).format("HH:mm DD/MM/YYYY")}</td>
            <td>{moment(brand.updated_at).format("HH:mm DD/MM/YYYY")}</td>
            <td className="text-center">
                <span className="text-primary" onClick={_handleClickEdit}>
                    Edit
                </span>
            </td>
        </tr>
    )
}

export default TableRow
